window.YTRACK = window.YTRACK || {};
let YTINITTIMER = null;
YTRACK = {    
    t(){
        let why_TapScore_widget = `<div style="background-color: #faf5e4; padding: 2px 16px 16px 32px;">
    <h3>Why Trust Tap Score?</h3>

    <ul>
        <li><b>Top rated:</b> We are recognized as the best water testing kit by both 
            <a href="https://www.nytimes.com/wirecutter/reviews/best-water-quality-test-kit-for-your-home/" target="_blank">Wirecutter</a> 
            and <a href="https://www.thespruce.com/best-water-testing-kits-4155794" target="_blank">The Spruce</a>, 
            and our Google Reviews are the best in the industry. 
            <a href="https://maps.app.goo.gl/H9guLVwJYjBB4Bu9A" target="_blank" style="text-decoration: underline;">See for yourself</a>.
        </li>
        
        <li><b>No affiliate links:</b> Unlike many water quality websites, we don't seek profit from filtration system sales. No commissions, just the facts.</li>
        
        <li><b>Independent laboratory testing:</b> Tap Score is powered by SimpleLab's network of 200+ certified laboratories. This ensures unbiased data <i>without</i> any conflicts of interest.</li>
        
        <li><b>Unbiased, expert advice:</b> Have questions about water quality? Our support team is available. 
            <a href="https://mytapscore.com/pages/support">Chat now.</a>
        </li>
    </ul>
</div>

`;


      let demo_widget = `<div style="background-color: #3CC0C4; padding: 8px;">
    <h4>This is a Demo Widget?</h4>
    <p> To create a new widget, first copy the "let… block" (from "let" to the little quote mark ' right before the ";" , paste the new one below the existing ones, and write your html code within that variable after the "=" sign.
Then copy the "if" statement block and create a new one below the existing one. Replace the variable names with your new widget name. for this demo for example, I'm replacing "whyTapscore_data_render" with "demoWidget_data_render", and also replacing "innerHTML= why_TapScore_widget" with "innerHTML= demo_widget".
</p>
<p> In your blog post you will use: <div id="demoWidget_data_render"  for example to render this html. All clear? </p> 
    </p>
</div>
`;
      
        if(document.getElementById('whyTapScore_data_render')){
          document.getElementById('whyTapScore_data_render').innerHTML= why_TapScore_widget ;
        }    
      if(document.getElementById('demoWidget_data_render')){
          document.getElementById('demoWidget_data_render').innerHTML= demo_widget ;
        }    

      
        clearInterval(YTINITTIMER);
    }
};
YTINITTIMER = setInterval(YTRACK.t, 500);